/**
 * Telerik Reports Fetch Interceptor
 */

var currentReportUrl = '';
var reportsFetchInterceptorInstalled = false;
var reportsParametersRequestsInFlight = 0;

function getCurrentReportUrl() {
  return currentReportUrl;
}

function prefilterTest() {
  if (reportsFetchInterceptorInstalled) {
    return;
  }

  reportsFetchInterceptorInstalled = true;

  var originalFetch = window.fetch.bind(window);
  var retryWait = 1000;
  var maxRetries = 3;

  function getAuthToken() {
    var token;
    if (Object.prototype.hasOwnProperty.call(window, 'sdPortalAuthToken')) {
      token = window.sdPortalAuthToken;
    } else {
      try {
        token = JSON.parse(window.localStorage.getItem('0-SDPortalClient'))?.authzData;
      } catch (e) {
        if (window.Sentry) {
          window.Sentry?.captureException(e);
        }
      }
    }
    return token;
  }

  function getRequestUrl(request) {
    if (typeof request === 'string') {
      return request;
    }

    if (request instanceof URL) {
      return request.toString();
    }

    return request && typeof request.url === 'string' ? request.url : '';
  }

  function getRequestMethod(request, options) {
    return String(options.method || (request && request.method) || 'GET').toUpperCase();
  }

  function getReportRequestState(request) {
    var requestUrl = getRequestUrl(request);
    var parsedUrl;

    try {
      parsedUrl = new URL(requestUrl, window.location.href);
    } catch (error) {
      return {
        requestUrl: requestUrl,
        isReportsRequest: false,
        isParametersRequest: false,
        isInfoDocumentsUrl: false,
      };
    }

    var path = parsedUrl.pathname.toLowerCase();
    var isTrustedReportsOrigin =
      parsedUrl.origin === window.location.origin || parsedUrl.origin === window.sdPortalReportsOrigin;
    var isReportsRequest =
      isTrustedReportsOrigin &&
      (path.indexOf('/api/reports/') >= 0 ||
        (!/^[a-z][a-z\d+.-]*:/i.test(requestUrl) && /^\/?clients\//i.test(requestUrl)));
    var isParametersRequest = isReportsRequest && path.indexOf('/clients/') >= 0 && path.indexOf('/parameters') >= 0;
    var isInfoDocumentsUrl =
      isReportsRequest &&
      path.indexOf('/documents/') >= 0 &&
      path.indexOf('/instances/') >= 0 &&
      path.indexOf('/clients/') >= 0 &&
      path.indexOf('/info') >= 0;

    return {
      requestUrl: requestUrl,
      isReportsRequest: isReportsRequest,
      isParametersRequest: isParametersRequest,
      isInfoDocumentsUrl: isInfoDocumentsUrl,
    };
  }

  function waitBeforeRetry(retryCount) {
    var attempt = maxRetries - retryCount + 1;
    return new Promise((resolve) => {
      setTimeout(resolve, retryWait * attempt);
    });
  }

  function fetchWithRetry(request, options, retryCount) {
    if (retryCount === undefined) {
      retryCount = maxRetries;
    }

    var requestState = getReportRequestState(request);
    var requestOptions = Object.assign({}, options);
    var method = getRequestMethod(request, requestOptions);
    var canRetrySafely = method === 'GET' || method === 'HEAD';

    if (requestState.isInfoDocumentsUrl) {
      currentReportUrl = requestState.requestUrl;
    }

    var token = getAuthToken();
    if (requestState.isReportsRequest && token) {
      var requestHeaders = requestOptions.headers || (request instanceof Request ? request.headers : undefined);
      var headers = new Headers(requestHeaders || {});
      headers.set('Authorization', 'Bearer ' + token);
      requestOptions.headers = headers;
    }

    return originalFetch(request, requestOptions)
      .then((response) => {
        if (
          requestState.isReportsRequest &&
          response.status === 401 &&
          retryCount > 0 &&
          typeof window.refreshToken === 'function'
        ) {
          return window
            .refreshToken()
            .then(() => waitBeforeRetry(retryCount).then(() => fetchWithRetry(request, options, retryCount - 1)));
        }

        if (requestState.isReportsRequest && response.status === 503 && retryCount > 0 && canRetrySafely) {
          return waitBeforeRetry(retryCount).then(() => fetchWithRetry(request, options, retryCount - 1));
        }

        return response;
      })
      .catch((error) => {
        if (requestState.isReportsRequest && retryCount > 0 && canRetrySafely) {
          return waitBeforeRetry(retryCount).then(() => fetchWithRetry(request, options, retryCount - 1));
        }

        throw error;
      });
  }

  window.fetch = function (request, options) {
    var requestState = getReportRequestState(request);
    var viewerContainer = requestState.isParametersRequest
      ? document.querySelector('.trv-parameters-area-overlay')
      : null;

    if (viewerContainer) {
      reportsParametersRequestsInFlight += 1;
      viewerContainer.style.display = 'block';
    }

    return fetchWithRetry(request, options || {}).finally(() => {
      if (viewerContainer) {
        reportsParametersRequestsInFlight = Math.max(0, reportsParametersRequestsInFlight - 1);
        if (reportsParametersRequestsInFlight === 0) {
          viewerContainer.style.display = 'none';
        }
      }
    });
  };
}
